import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiEnvelope, LoginRequest } from '../../models/auth.dto';
import {
  CompanyResponse,
  CreateUserRequest,
  DisableUserRequest,
  MeCompanyResponse,
  RegisterCompanyRequest,
  RegisterViaPortalRequest,
  RegistrationResponse,
  UserResponse,
} from '../../models/company.dto';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  private apiUrl = environment.cbdx_service.api_path;

  constructor(private http: HttpClient) {}

  register(request: RegisterCompanyRequest): Observable<ApiEnvelope<RegistrationResponse>> {
    return this.http.post<ApiEnvelope<RegistrationResponse>>(
      `${this.apiUrl}/companies/register`,
      request
    );
  }

  /**
   * Public, no token. Verifies email/password against the itrace middleware and lists its
   * companies via `/me/companies/`, each tagged with whether it is already registered here.
   */
  middlewareCompanies(request: LoginRequest): Observable<ApiEnvelope<MeCompanyResponse[]>> {
    return this.http.post<ApiEnvelope<MeCompanyResponse[]>>(
      `${this.apiUrl}/companies/middleware-companies`,
      request
    );
  }

  /** Public, no token. The final step of the itrace-portal registration flow. */
  registerViaPortal(request: RegisterViaPortalRequest): Observable<ApiEnvelope<RegistrationResponse>> {
    return this.http.post<ApiEnvelope<RegistrationResponse>>(
      `${this.apiUrl}/companies/register-via-portal`,
      request
    );
  }

  me(): Observable<ApiEnvelope<CompanyResponse>> {
    return this.http.get<ApiEnvelope<CompanyResponse>>(`${this.apiUrl}/companies/me`);
  }

  listUsers(): Observable<ApiEnvelope<UserResponse[]>> {
    return this.http.get<ApiEnvelope<UserResponse[]>>(`${this.apiUrl}/companies/me/users`);
  }

  addUser(request: CreateUserRequest): Observable<ApiEnvelope<UserResponse>> {
    return this.http.post<ApiEnvelope<UserResponse>>(`${this.apiUrl}/companies/me/users`, request);
  }

  disableUser(userId: string, request: DisableUserRequest): Observable<ApiEnvelope<UserResponse>> {
    return this.http.post<ApiEnvelope<UserResponse>>(
      `${this.apiUrl}/companies/me/users/${userId}/disable`,
      request
    );
  }

  enableUser(userId: string): Observable<ApiEnvelope<UserResponse>> {
    return this.http.post<ApiEnvelope<UserResponse>>(`${this.apiUrl}/companies/me/users/${userId}/enable`, {});
  }
}
